import { createAsyncThunk, createSlice, isRejected, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../../app/store'
import fetchAPI from '../../common/fetchAPI'
import { TaskRequestHoursStateClass } from './interfaces/taskRequestHoursStateClass';

const initialState: TaskRequestHoursStateClass = {
    isLoading: false,
    status: 'idle',
    taskRequestHoursList: [],
    taskRequestApprovalList:[],
    selectedRecord: {},
    isReload: false,
    accountprojecttaskid: 0,
    startDate: new Date().toISOString(),
    endDate: new Date().toISOString(),
    CurrentCultureName: "",
    TaskIdForApproval:0,
};

interface IThunkApi {
    state: {
        taskRequestHours: TaskRequestHoursStateClass;
    },
}

export const getTaskRequestHoursAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'taskRequestHours/getTaskRequestHours',
        async (arg, thunkApi) => {       
            const response = await fetchAPI('api/V2/Tasks/GetDataAccountTaskRequest/' + arg, 'Get', '', true, 'a73f036e-6d84-440b-85e0-70e157c5eef7');           
            const json = await response.json();
            return json;
        }
    )


    export const getDataForTaskRequestApprovalAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'taskRequestHours/getDataForTaskRequestApproval',
        async (arg, thunkApi) => {  
            const {StartDate} = arg
            const {EndDate} = arg 
            const {AccountProjectTaskId} = arg   
            const response = await fetchAPI('api/V2/Tasks/GetDataForTaskRequestApproval/' + StartDate + '/' + EndDate + '/' + AccountProjectTaskId, 'Get', '', true, 'a73f036e-6d84-440b-85e0-70e157c5eef7');           
            const json = await response.json();
            return json;
        }
    )

    export const addAccountTaskRequestasync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'taskRequestHours/addAccountTaskRequest',
        async (arg, thunkApi) => {    
            const {ApprovedOn,RejectedOn,CreatedOn,ModifiedOn, ...argwithoutId} = arg 
            const response = await fetchAPI('api/V2/Tasks/InsertAccountTaskRequest', 'POST', argwithoutId , true, 'a73f036e-6d84-440b-85e0-70e157c5eef7');
            const json = await response.json();
            return json;
        }
    )

    export const ApproveSelectedAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "taskRequestHours/V2/Tasks/UpdateTaskRequestApprovals",
        async (arg, thunkApi) => {
            const { List, id} = arg;           
            let filteredList: any = [];
            let updatedList: any = [];
            if (id === "Approve") {
                filteredList = List.filter((item: any) => item.isSelected === 1 && item.Approved === true);
                updatedList = filteredList.map((item: any) => {
                    if (item.isSelected === 1 && item.Approved === true) {
                        return {
                            ...item, IsApproved: true, IsRejected: false
                        };
                    }
                });
            }
            else {
                filteredList = List.filter((item: any) => item.isSelected === 1 && item.Rejected === true);
                updatedList = filteredList.map((item: any) => {
                    if (item.isSelected === 1 && item.Approved === true) {
                        return {
                            ...item, IsApproved: false, IsRejected: true
                        };
                    }
                });
            }  

            const finalArray = updatedList.map((item:any) => ({
                AccountTaskRequestId: item.AccountTaskRequestId,
                AccountProjectTaskId: item.AccountProjectTaskId,
                IsApproved: item.IsApproved,
                IsRejected: item.IsRejected,
                RequestedEmployeeId: item.AccountEmployeeId,
                RequestedAllocationHours: item.NewAllocationHours,
                AccountTaskName: item.TaskName,
                ...item
            }));
            const response = await fetchAPI("api/V2/Tasks/UpdateTaskRequestApprovals", "PUT", finalArray, true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const json = response.json();
            return json;
        }
    )

export const SingleApproveOrRejectAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "Tasks/v2/SingleApproveOrReject",
        async (arg, thunkApi) => {
            const { List,id, StartDate, EndDate} = arg;
            let updatedList: any = [];
            if (id === "Approve") {
                updatedList = List.map((item: any) => {
                    return {
                        ...item, IsApproved: true, IsRejected: false
                    };
                });
            }
            else {
                updatedList = List.map((item: any) => {
                    return {
                        ...item, IsApproved: false, IsRejected: true
                    };
                });
            }
            const finalArray = updatedList.map((item:any) => ({
                AccountTaskRequestId: item.AccountTaskRequestId,
                AccountProjectTaskId: item.AccountProjectTaskId,
                IsApproved: item.IsApproved,
                IsRejected: item.IsRejected,
                RequestedEmployeeId: item.AccountEmployeeId,
                RequestedAllocationHours: item.NewAllocationHours,
                AccountTaskName: item.TaskName,
               ...item
            }));
            const response = await fetchAPI("api/V2/Tasks/UpdateTaskRequestApprovals", "PUT", finalArray, true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const json = response.json();
            return json;
        }
    )

    
    
  
export const taskRequestHoursSlice = createSlice({
    name: 'expensePolicy',
    initialState,
    reducers: {
        resetSelectedRecordObjectInState: (state) => {
            state.selectedRecord = {};
        },        
        checkedState: (state, action) => {
            const currentindex = state.taskRequestApprovalList.findIndex((item) => item.AccountTaskRequestId == action.payload);
            const newArray = [...state.taskRequestApprovalList];
            newArray[currentindex] = { ...newArray[currentindex], isSelected: 1, 'Approved': true, 'Rejected': true };
            state.taskRequestApprovalList = newArray;
        },
        unCheckedState: (state, action) => {
            const currentindex = state.taskRequestApprovalList.findIndex((item) => item.AccountTaskRequestId == action.payload);
            const newArray = [...state.taskRequestApprovalList];
            newArray[currentindex] = { ...newArray[currentindex], isSelected: 0, 'Approved': false, 'Rejected': false };
            state.taskRequestApprovalList = newArray;
        },
        checkedAllState: (state) => {
            const newArray = state.taskRequestApprovalList.map((item) => ({
                ...item,
                isSelected: 1,
                'Approved': true,
                'Rejected': true
            }));
            state.taskRequestApprovalList = newArray;
        },
        unCheckedAllState: (state) => {
            const newArray = state.taskRequestApprovalList.map((item) => ({
                ...item,
                isSelected: 0,
                'Approved': false,
                'Rejected': false
            }));
            state.taskRequestApprovalList = newArray;
        },
       
        updateAccountProjectTaskId: (state, action: PayloadAction<number>) => {
            state.accountprojecttaskid = action.payload;
        },
        setDateRangeValue: (state, action) => {
            const { startDate, endDate } = action.payload;
            state.startDate = startDate;
            state.endDate = endDate;
        },
        setComments: (state, action) => {
            const { Comments, AccountTaskRequestId } = action.payload;
            const currentindex = state.taskRequestApprovalList.findIndex((item) => item.AccountTaskRequestId == AccountTaskRequestId);
            const newArray = [...state.taskRequestApprovalList];
            newArray[currentindex] = { ...newArray[currentindex], Comments: Comments };
            state.taskRequestApprovalList = newArray;
        },
        updateTaskIdForApproval: (state, action: PayloadAction<number>) => {
            state.TaskIdForApproval = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getTaskRequestHoursAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;

            })
            .addCase(getTaskRequestHoursAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                if (Object.keys(payload.data).length === 0) {
                    state.taskRequestHoursList = [];
                } else {
                    state.taskRequestHoursList = payload.data;
                    state.taskRequestHoursList.map((item: any) => {
                        item.isSelected = 0
                    });
                }
               
                state.isReload = false;
                state.isLoading = false;
                state.selectedRecord = {};
            })
            .addCase(getTaskRequestHoursAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;                
            })

            .addCase(getDataForTaskRequestApprovalAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;

            })
            .addCase(getDataForTaskRequestApprovalAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                if (Object.keys(payload.data).length === 0) {
                    state.taskRequestApprovalList = [];
                    console.log('payload.data',payload.data);
                } else {
                    state.taskRequestApprovalList = payload.data;
                    state.taskRequestApprovalList.map((item: any) => {
                        item.isSelected = 0
                        item.isFiltered = -1;
                        item.approvedButtonClass = 'btn-light-success btn-sm';
                        item.rejectedButtonClass = 'btn-light-danger btn-sm';
                        if (!item.hasOwnProperty('Comments')) {
                            item.Comments = "";
                            item.Approved = false;
                            item.Rejected = false;
                        }
                    });
                }
                state.CurrentCultureName = payload.data.CurrentCultureName;
                state.isReload = false;
                state.isLoading = false;
                state.selectedRecord = {};
            })
            .addCase(getDataForTaskRequestApprovalAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;                
            })


            .addCase(addAccountTaskRequestasync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;

            })
            .addCase(addAccountTaskRequestasync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;

            })
            .addCase(addAccountTaskRequestasync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;

            })

            .addCase(ApproveSelectedAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(ApproveSelectedAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;

            })
            .addCase(ApproveSelectedAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })

            .addCase(SingleApproveOrRejectAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(SingleApproveOrRejectAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;

            })
            .addCase(SingleApproveOrRejectAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })

          
    }
})
export const {
    resetSelectedRecordObjectInState,checkedState, unCheckedState, checkedAllState, 
    unCheckedAllState,updateAccountProjectTaskId,setDateRangeValue,setComments,updateTaskIdForApproval
} = taskRequestHoursSlice.actions

export const taskRequestHoursStateClass = (state: RootState) => state.taskRequestHours
export default taskRequestHoursSlice.reducer